import { render, staticRenderFns } from "./BoWebSettings.vue?vue&type=template&id=886f64d0&"
import script from "./BoWebSettings.vue?vue&type=script&lang=js&"
export * from "./BoWebSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports